module.exports = __webpack_public_path__ + "img/1543416569.2fde3ff9.jpg";